import { render } from "./IndexRight.vue?vue&type=template&id=44b2c421"
import script from "./IndexRight.vue?vue&type=script&lang=js"
export * from "./IndexRight.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__